import { flow } from 'lodash';
import { connect } from 'react-redux';
import ModuleFeedback from './ModuleFeedback';

const mapStateToProps = state => ({
  scores: state.task.scores,
  possibleScores: state.task.possibleScores
});

export default flow(connect(mapStateToProps))(ModuleFeedback);



// WEBPACK FOOTER //
// ../core/src/components/ModuleFeedback/index.js